export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : ''
        this.workOrderId = item != null ? item.workOrderId : ''
        this.userId = item != null ? item.userId : '';
        this.startTime = item != null ? item.startTime : '';
        this.endTime = item != null ? item.endTime : '';
    }
}